import { Button, DownloadIcon} from "melco-ui";
import { useTranslation } from "react-i18next";
import { saveAs } from "file-saver";

import {  useConfirm } from "melco-shared-logic";
import { useUserLogFilesDownload } from "../../hooks/users/useUserLogFilesDownload";


type LogFilesDownloadActionButtonProps = {
    fileNameToSaveDownload?: string;  
    userIdToDownloadLogFiles:string;
    logFileIdToDownload: string ;
    callBackFn:()=> void
};

export const LogFilesDownloadActionButton: React.FC<
    LogFilesDownloadActionButtonProps
> = ({ userIdToDownloadLogFiles, fileNameToSaveDownload, logFileIdToDownload }) => {
    const { t } = useTranslation();


    const downloadLogfile = useUserLogFilesDownload(userIdToDownloadLogFiles);

    const confirmDownloadLogfile = useConfirm(
        async () => {

       const blob =     await downloadLogfile({
          "id": logFileIdToDownload,
         
        })
      
        if (blob) {
          saveAs(blob, fileNameToSaveDownload);
        }
        else {
         console.log("It is not blob");
        }

//        console.log(blob)
     //   callBackFn();
         //console.log(response);
        },
        {
          translationPrefix: "users.tabs.logfiles.actions.download",

        }
      );
  

    



    return (

        <>
         <div > {
            <Button
              icon={<DownloadIcon/>}
              type="primary"
  
              onClick={() => {
               
                 confirmDownloadLogfile();
              }}
            >
             {t("users.tabs.logfiles.actions.download.button")}
            </Button>
          }
          </div></>
    );
};
